import axios from 'axios';

import { API_CONFIG } from '../config/apiConfig';

import { store } from '../store';

import { logout } from '../store/authSlice';

import { showGlobalError } from '../store/uiSlice';


const apiClient = axios.create({

    baseURL: API_CONFIG.baseUrl,

    timeout: API_CONFIG.timeout,

    headers: API_CONFIG.headers,

});



// Add request interceptor to include auth token

apiClient.interceptors.request.use(

    (config) => {

        // Try to get token from store first, then localStorage

        const token = store.getState()?.auth?.token || localStorage.getItem('token');

        if (token) {

            config.headers.Authorization = `Bearer ${token}`;

        }

        return config;

    },

    (error) => {

        return Promise.reject(error);

    }

);



// Add response interceptor for error handling

apiClient.interceptors.response.use(

    (response) => {

        // Catch cases where success is false and there's a specific auth error

        if (response.data?.success === false) {

            const errorMsg = response.data?.error || response.data?.message || '';

            const isVerifyTokenEndpoint = response.config?.url?.includes('verify-document-token');

            const errorMsgStr = typeof errorMsg === 'string' ? errorMsg : JSON.stringify(errorMsg);

            if (errorMsgStr.toLowerCase().includes("token") && !isVerifyTokenEndpoint) {

                handleUnauthorized();

            }

        }

        return response;

    },

    (error) => {

        const status = error.response?.status;

        const data = error.response?.data;

        const isLoginEndpoint = error.config?.url?.includes('/auth/login');

        const isVerifyTokenEndpoint = error.config?.url?.includes('verify-document-token');

        const hasTokenInError = (val) => {
            if (!val) return false;
            const str = typeof val === 'string' ? val : JSON.stringify(val);
            return str.toLowerCase().includes('token');
        };

        if (status === 401 || (data?.success === false && (hasTokenInError(data?.error) || hasTokenInError(data?.message)))) {

            // Only redirect if NOT login and it's an auth error

            if (!isLoginEndpoint && !isVerifyTokenEndpoint) {

                handleUnauthorized();

            }

        }



        // Show global error modal for all non-success responses that aren't redirecting

        if (status !== 200 || data?.success === false) {

            let errorMessage = 'An unexpected error occurred';
            if (data) {
                if (data.error && Array.isArray(data.error)) {
                    const valErrors = data.error.map(err => err.msg || err.message || JSON.stringify(err)).join(', ');
                    errorMessage = `${data.message || 'Validation failed'}: ${valErrors}`;
                } else {
                    const rawErrorMsg = data.message || data.error || (typeof data === 'string' ? data : null);
                    if (rawErrorMsg) {
                        errorMessage = typeof rawErrorMsg === 'string' ? rawErrorMsg : JSON.stringify(rawErrorMsg);
                    }
                }
            } else if (error.message) {
                errorMessage = error.message;
            }



            if (!(status === 401 && !isLoginEndpoint) && !error.config?.skipGlobalError && !isVerifyTokenEndpoint) {

                store.dispatch(showGlobalError({

                    statusCode: status,

                    errorMessage: errorMessage,

                    errorDetails: (data && typeof data !== 'string') ? JSON.stringify(data, null, 2) : null

                }));

            }

        }



        return Promise.reject(error);

    }

);



function handleUnauthorized() {

    console.error('Authentication required or token invalid - Logging out');

    store.dispatch(logout());

    if (typeof window !== 'undefined') {

        // Redirect to login if not already there

        if (!window.location.pathname.includes('/login')) {

            window.location.href = '/login';

        }

    }

}



export default apiClient;

